export const AUTH_TABS = ['signin', 'register'] as const;
export type AuthTab = (typeof AUTH_TABS)[number];

export interface AuthCardProps {
  onSwitchToRegister?: () => void;
}
